import type { PanelSalesInquiryDetailDto } from '@icebreaker/shared';
import { Tag } from '@icebreaker/ui';
import { useTranslation } from '@/shared/i18n/i18n-provider';
import { REFERRAL_LEAD_STATUS_VARIANT, referralStatusLabel } from '../model/referral-status';
import styles from './sales.module.css';

/**
 * "REFERANS KODU" SATIRININ DEĞERİ (Story 3). Kodlu talepte kod (mono) ve bu
 * kurum için durumu; etiket metinleri "Kredi yükle" penceresiyle aynıdır
 * (`referral-status`). Kodsuz talepte "Girilmedi".
 */
export function ReferralCodeValue({ data }: { data: PanelSalesInquiryDetailDto }) {
  const t = useTranslation();
  if (data.referralCode === null || data.referralCodeStatus === null) {
    return <>{t.t('admin.sales.detail.referral.none')}</>;
  }
  return (
    <span className={styles.referralValue}>
      <span className={styles.mono}>{data.referralCode}</span>
      <Tag variant={REFERRAL_LEAD_STATUS_VARIANT[data.referralCodeStatus]}>
        {referralStatusLabel(t, data.referralCodeStatus, data.referralCodeUsedAt)}
      </Tag>
    </span>
  );
}
